import { render, staticRenderFns } from "./PaseModal.vue?vue&type=template&id=d97085b8&"
import script from "./PaseModal.vue?vue&type=script&lang=js&"
export * from "./PaseModal.vue?vue&type=script&lang=js&"
import style0 from "./PaseModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports